import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const e=i("israel",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="white" />
            <path
                d="M0 6L24 6V8.5L0 8.5L0 6Z"
                fill="#0038B8" />
            <path
                d="M0 16.5L24 16.5V19L0 19L0 16.5Z"
                fill="#0038B8" />
            <path
                d="M11.9993 15.9641L10.9084 14.2321H8.72656L9.81747 12.5001L8.72656 10.7681H10.9084L11.9993 9.03613L13.0902 10.7681H15.272L14.1811 12.5001L15.272 14.2321H13.0902L11.9993 15.9641ZM11.6011 14.2321L11.9993 14.8641L12.3975 14.2321H11.6013H11.6011ZM13.4365 13.6821H14.2326L13.8344 13.0501L13.4362 13.6821H13.4365ZM11.2546 13.6821H12.7437L13.4882 12.5001L12.7437 11.3181H11.2546L10.5102 12.5001L11.2546 13.6821ZM9.76554 13.6821H10.5617L10.1635 13.0501L9.76533 13.6821H9.76554ZM13.4365 11.3179L13.8346 11.9499L14.2328 11.3179H13.4367H13.4365ZM9.76554 11.3179L10.1637 11.9499L10.5619 11.3179H9.76576H9.76554ZM11.6009 10.7679H12.397L11.9989 10.1359L11.6007 10.7679H11.6009Z"
                fill="#0038B8" />
        </svg>
    `),M=i("israel_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66557)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-4.5 0.5L28.5 0.5L28.5 24.5L-4.5 24.5L-4.5 0.5Z"
                    fill="white" />
                <path
                    d="M-4.5 2.75L28.5 2.75V6.5L-4.5 6.5L-4.5 2.75Z"
                    fill="#0038B8" />
                <path
                    d="M-4.5 18.5L28.5 18.5V22.25L-4.5 22.25L-4.5 18.5Z"
                    fill="#0038B8" />
                <path
                    d="M12 17.6967L10.5 15.0987H7.5L9 12.5007L7.5 9.90269H10.5L12 7.30469L13.5 9.90269L16.5 9.90269L15 12.5007L16.5 15.0987L13.5 15.0987L12 17.6967ZM11.4525 15.0987L12 16.0467L12.5475 15.0987H11.4528H11.4525ZM13.9761 14.2737H15.0708L14.5233 13.3257L13.9758 14.2737H13.9761ZM10.9761 14.2737H13.0236L14.0472 12.5007L13.0236 10.7277H10.9761L9.9525 12.5007L10.9761 14.2737ZM8.9286 14.2737H10.0233L9.4758 13.3257L8.9283 14.2737H8.9286ZM13.9761 10.7274L14.5236 11.6754L15.0711 10.7274L13.9764 10.7274H13.9761ZM8.9286 10.7274L9.4761 11.6754L10.0236 10.7274H8.9289H8.9286ZM11.4522 9.90239H12.5469L11.9994 8.95439L11.4519 9.90239H11.4522Z"
                    fill="#0038B8" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66557">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{e as Israel,M as IsraelRounded};
